import { h } from 'preact';
import AppLayout from './layouts/AppLayout';
import NativeForm from './NativeForm';
import * as siteActions from '../actions/site';
import { navigateTo } from '../actions/navigation';

function SiteForm() {
  return (
    <AppLayout backUrl="/account/sites" title="New Site" data-component="SiteForm">
      <div className="content-padded">
        <NativeForm onSubmit={handleSubmit}>
          <label>
            Title: <br />
            <input name="title" type="text" required />
          </label>
          <label>
            Website URL (ex: &quot;https://www.includecart.com&quot;): <br />
            <input name="url" type="url" required />
          </label>
          <button type="submit" className="btn btn-primary btn-block">Add New Site</button>
        </NativeForm>
      </div>

      <div className="bar bar-standard bar-footer">
        <div className="content-padded text-center">
          <p>A new webiste can be setup and fully configured in test mode for free. You will only pay when taking your site live.</p>
        </div>
      </div>
    </AppLayout>
  );
}

// Only fires when form is valid and submitted
function handleSubmit(event, data) {
  // Create doc with Firebase client
  siteActions.remote.create(data)
    .then(doc => {
      navigateTo('/account/sites');
    });
}

SiteForm.propTypes = {
};

export default SiteForm;
